var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeedbackSent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 127,
    height: 107,
    viewBox: "0 0 127 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: 17
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 759"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M122.1 54.9C122.1 69.1 116.3 81.9 107 91.1C97.9002 100.2 85.3002 105.7 71.4002 105.7C57.6002 105.7 45.0002 100.1 35.8002 91.1C26.5002 81.9 20.7002 69.1 20.7002 54.9C20.7002 26.8 43.4002 4.09998 71.4002 4.09998C99.4002 4.09998 122.1 26.9 122.1 54.9Z",
    fill: "#F1F3F9",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M117.7 21.6C119.964 21.6 121.8 19.7643 121.8 17.5C121.8 15.2356 119.964 13.4 117.7 13.4C115.436 13.4 113.6 15.2356 113.6 17.5C113.6 19.7643 115.436 21.6 117.7 21.6Z",
    fill: "#F1F3F9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M123.7 5.6C125.246 5.6 126.5 4.3464 126.5 2.8C126.5 1.2536 125.246 0 123.7 0C122.154 0 120.9 1.2536 120.9 2.8C120.9 4.3464 122.154 5.6 123.7 5.6Z",
    fill: "#F1F3F9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M22.3 21.5C23.8464 21.5 25.1 20.2464 25.1 18.7C25.1 17.1536 23.8464 15.9 22.3 15.9C20.7536 15.9 19.5 17.1536 19.5 18.7C19.5 20.2464 20.7536 21.5 22.3 21.5Z",
    fill: "#F1F3F9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M5.2 75.5C8.07188 75.5 10.4 73.1719 10.4 70.3C10.4 67.4281 8.07188 65.1 5.2 65.1C2.32812 65.1 0 67.4281 0 70.3C0 73.1719 2.32812 75.5 5.2 75.5Z",
    fill: "#F1F3F9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M107 28.3V91.1C97.8998 100.2 85.2998 105.7 71.3998 105.7C57.5998 105.7 44.9998 100.1 35.7998 91.1V28.3H107Z",
    fill: "white",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union",
    d: "M67.9431 55.6391L84.0833 39.4989L88.8208 44.2365L68.032 65.0252L68.0091 65.0022L67.9201 65.0912L53.9902 51.1614L58.7278 46.4238L67.9431 55.6391Z",
    fill: "#D6DCE8",
    stroke: "#AAB2C5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M89.6002 73.6H53.2002V78.2H89.6002V73.6Z",
    fill: "#D6DCE8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M89.6002 83.7H53.2002V88.3H89.6002V83.7Z",
    fill: "#D6DCE8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M80.7001 93.9H62.1001V98.5H80.7001V93.9Z",
    fill: "#D6DCE8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedbackSent);
export default __webpack_public_path__ + "static/media/feedback_sent.c901f033c0620e8c388b154c4ff16e2b.svg";
export { ForwardRef as ReactComponent };